import styled from 'styled-components';
import breakpoint from 'components/utils/responsive';
import { colorToken } from "components/utils/constants";

export default styled.div`
    min-height: 100vh;
    display: flex;
    padding-top: 95px;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    background-image: url('/assets/img/bg-home.jpg');
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    
    img {
        max-width: 100%;
    }
    @media ${breakpoint.md} {
        padding-top: 100px;
        /* flex-basis: 50%;
        flex-direction: row; */
    }
`;

export const StyleButtonContainer = styled.div`
    margin-bottom: 8px;
    padding: 0 16px;
`;

export const StyleContentWrapperNumeros = styled.div`
    display: flex;
    flex-direction: column;
    padding: 12px;
    max-width: 1268px;
    max-height: ${({ openedStep }) => (openedStep ? "auto" : "0")};
    padding: ${({ openedStep }) => (openedStep ? "24px 12px" : "0")};
    width: ${({ openedStep }) => (openedStep ? "100%" : "0")};
    overflow-y: hidden;
    transition: max-height linear 0.2s;
    @media ${breakpoint.md} {
    }

`;


export const StyleImg = styled.img`
    max-width: 100%;
    border-radius: 12px 12px 0 0;
    @media ${breakpoint.md} {
        border-radius: 24px 0 0 24px;
    }
`;
export const StyleKvWrapper = styled.div`
    max-width: 645px;
    width: 100%;
    margin-bottom: -12px;
    /* background-image: url('/assets/img/kvkv.jpg');
    background-repeat: no-repeat;
    background-size: cover; */
    @media ${breakpoint.md} {
        margin: 0;
        margin-right: -24px;
    }
`;
export const StyleContent = styled.div`
    max-width: 645px;
    background-color: ${colorToken.white};
    border-radius: 12px;
    /* padding: 24px 24px; */
    max-height: ${({ openedStep }) => (openedStep ? "auto" : "0")};
    padding: ${({ openedStep }) => (openedStep ? "24px 24px" : "0")};
    width: ${({ openedStep }) => (openedStep ? "100%" : "0")};
    overflow: ${({ openedStep }) => (openedStep ? "default" : "hidden")};
    @media ${breakpoint.md} {
        display: flex;
        /* padding: 24px 48px; */
        border-radius: 24px;
        max-width: unset;
        justify-content: center;
        flex-direction: column;
        align-items: center;
    }
    small {
        font-size: 1.2rem;
        font-weight: bold;
    }

    hr {
        width: 100%;
    }
`;


export const StyleParagraphText = styled.div`
    font-weight: 300;
    font-family: 'VWHeadWeb';
    font-size: 18px;
    color: #4a4a4a;
`;

export const StyleTitleText = styled.h1`
    font-weight: 300;
    font-family: "VWHeadWeb";
    font-size: 30px;
    margin-bottom: 12px;
    strong{
        font-family: 'VWHeadWeb';
        font-weight: bold;
        color: #00aff0;
        display: block;
    }
`;

export const StyleNumeros = styled.div`
    display: flex;
    gap: 0 12px;
    flex-wrap: wrap;
    margin-bottom: 12px;
`;

export const StyleNumeroItem = styled.div`
    color: ${colorToken.color1};
    font-weight: bold;
    font-size: 1.6rem;
    width: 80px;
`;

export const StyleUser = styled.div`
    color: ${colorToken.white};
    text-align: right;
    font-size: 16px;
    padding-right: 24px;
    line-height: 32px;
`;

export const StyleContentNumeros = styled.div`
    width: 100%;
    background-color: ${colorToken.white};
    border-radius: 12px;
    padding: 24px 12px;
    text-align: center;
    img { 
        margin-bottom: 36px;
    }
    @media ${breakpoint.md} {
        padding: 24px 48px;
        /* display: flex;
        border-radius: 24px;
        max-width: unset;
        justify-content: start;
        flex-direction: column;
        align-items: center; */
    }
    small {
        font-size: 1.2rem;
        font-weight: bold;
    }
    > * {
        text-align: left;
    }

    ${StyleTitleText}{
        font-size: 1.6rem;
        @media ${breakpoint.md} {
            font-size: 2.4rem;
        }
    }
`;




//================================================

// export const StyleContent = styled.div`
//     padding: 0 16px 32px;
//     button{
//         margin-top: 12px;
//     }
//     @media ${breakpoint.lg} {
//         flex-basis: 68%;
//     }
// `;


export const StyleWrapperInput = styled.div`

`

export const StyleKeyVisualWrapper = styled.div`
    background-image: url("/assets/img/volksvale_kv.jpg");
    background-size: 100%;
    background-repeat: no-repeat;
    background-color: ${colorToken.color3};
    background-position: top center;
    /* flex-basis: 100%; */
    flex-basis: 280px;
    @media ${breakpoint.md} {
        flex-basis: 40%;
    }
    @media ${breakpoint.lg} {
        flex-basis: 50%;
    }
`;

// export const StyleContentWrapper = styled.div`
//     background-image: url("/assets/img/volksvale_bg.png");
//     background-position: center;
//     background-size: cover;
//     flex-grow: 1;
//     display: flex;
//     align-items: center;
//     justify-content: center;
//     @media ${breakpoint.lg} {
//         justify-content: flex-start;
//         padding-left: 6%;
//         padding-top: 80px;
//     }
// `;

export const StyleLuckNumberContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    margin-bottom: 24px;
    h2 {
        margin-bottom: 0;
        padding-bottom: 0;
        font-size: 1.5rem;
    }

    strong {
        font-size: 4rem;
        line-height: 40px;
        color: ${colorToken.color1};
        display: block;
    }
`
export const StyleDataBestDrive = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    align-self: flex-start;
    margin-bottom: 8px;
`

export const StyleDescriptionBestDrive = styled.div`
font-size: 1.2rem;
margin: 0;
line-height: 16px;
`

export const StyleInfoBestDrive = styled.div`
font-size: 1.6rem;
line-height: 18px;
&.highlight {
    color: ${colorToken.color1};
    font-weight: bold;
    font-size: 1.8rem;   
}
`